import { Component } from "@angular/core";
import { UntypedFormBuilder, Validators } from "@angular/forms";
import { MatDialogRef } from "@angular/material/dialog";
import { MaskService } from "@core/services/mask.service";

@Component({
    templateUrl: "./modal-approval.component.html",
    styleUrls: ["./modal-approval.component.scss"],
    standalone: false
})
export class ModalApprovalComponent {
  modalForm = this.fb.group({
    approvalCode: ["", Validators.required],
    observation: [""]
  });

  constructor(
    private matDialogRef: MatDialogRef<ModalApprovalComponent>,
    private maskService: MaskService,
    private fb: UntypedFormBuilder
  ) {}

  closeDialog(isSubmitted: boolean): void {
    this.matDialogRef.close(isSubmitted ? this.modalForm.getRawValue() : null);
  }

  getOnlyNumbersMask(): string {
    return this.maskService.getOnlyNumbersMask();
  }
}
